import Icon from '../components/Icon.vue'

Icon.register({
  eraser: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.9 273.9C516.7 255.2 516.7 224.8 497.9 206.1L337.9 46.1C319.2 27.3 288.8 27.3 270.1 46.1L14.1 302.1C-4.7 320.8-4.7 351.2 14.1 369.9L110.1 465.9A48-48 0 0 1 144 480H500C506.6 480 512 474.6 512 468V428C512 421.4 506.6 416 500 416H355.9L497.9 273.9zM195.3 211.3L332.7 348.7 265.4 416H150.6L70.6 336 195.3 211.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/eraser.js
// module id = iAkl
// module chunks = 144